import React from 'react';

type AlcoholIconProps = {
  color: '#FFFFFF' | '#30537E';
}

const AlcoholIcon: React.FC<AlcoholIconProps> = ({ color }) => {
  return (
    React.createElement('svg', { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
      React.createElement('path', { d: "M14.8 11.95L9.84995 7H16.55L18.35 5H7.84995L5.84995 3H19.4249C19.875 3 20.2416 3.15433 20.525 3.463C20.8083 3.77167 20.95 4.11733 20.95 4.5C20.95 4.68333 20.9166 4.85833 20.85 5.025C20.7833 5.19167 20.6833 5.35 20.5499 5.5L14.8 11.95ZM6.99995 21C6.71662 21 6.47928 20.904 6.28795 20.712C6.09662 20.52 6.00062 20.2827 5.99995 20C5.99995 19.7167 6.09595 19.4793 6.28795 19.288C6.47995 19.0967 6.71728 19.0007 6.99995 19H11V13.825L2.09995 4.925C1.91662 4.74167 1.82495 4.51267 1.82495 4.238C1.82495 3.96333 1.91662 3.72567 2.09995 3.525C2.29995 3.325 2.53762 3.225 2.81295 3.225C3.08828 3.225 3.32562 3.325 3.52495 3.525L20.5 20.5C20.7 20.7 20.7999 20.9333 20.7999 21.2C20.7999 21.4667 20.7 21.7 20.5 21.9C20.2999 22.1 20.0626 22.2 19.788 22.2C19.5133 22.2 19.2756 22.1 19.075 21.9L13.025 15.85L13 19H17C17.2833 19 17.521 19.096 17.713 19.288C17.905 19.48 18.0006 19.7173 18 20C18 20.2833 17.904 20.521 17.712 20.713C17.52 20.905 17.2826 21.0007 17 21H6.99995Z", fill: color })
    )
  );
};

export default AlcoholIcon;
